module.exports = {"130928100":"桑园镇","130928101":"铁城镇","130928102":"于集镇","130928103":"梁集镇","130928104":"安陵镇","130928200":"曹家洼乡","130928201":"东宋门乡","130928202":"杨家寺乡","130928203":"沟店铺乡","130928204":"何庄乡","130928400":"吴桥经济技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130928.json
// module id = 309
// module chunks = 0